export default {
  "site.name": "Itaobuy Spreadsheet Italia",
  "site.tagline": "Guida Completa, Recensione e Sicurezza",
  "nav.home": "Home",
  "nav.guide": "Guida",
  "nav.faq": "FAQ",
  "nav.categories": "Categorie",
  "nav.shopping_guide": "Guida agli Acquisti",
  "cta.itaobuy_sheet": "itaobuy sheet",
  "cta.buy_now": "buy it now",
  "cta.scopri_guida": "Scopri la guida Itaobuy Spreadsheet",
  "cta.come_funziona": "Come funziona Itaobuy",
  "cta.vai_guida_completa": "Vai alla guida completa Itaobuy Spreadsheet",
  "hero.title_line1": "Itaobuy Spreadsheet:",
  "hero.title_line2": "la guida italiana completa",
  "hero.title_line3": "per trovare prodotti migliori dalla Cina",
  "hero.welcome": "Benvenuto su Itaobuy Spreadsheet Italia, la piattaforma informativa dedicata agli utenti italiani che vogliono conoscere meglio il mondo di Itaobuy Spreadsheet.",
  "hero.desc1": "Negli ultimi anni sempre più persone cercano soluzioni più efficienti per individuare prodotti, confrontare informazioni e comprendere meglio il processo di acquisto internazionale.",
  "hero.desc2": "Itaobuy Spreadsheet rappresenta uno strumento organizzato che permette di raccogliere informazioni sui prodotti, analizzare caratteristiche, confrontare alternative e prendere decisioni più consapevoli.",
  "hero.bullet1": "cos'è Itaobuy Spreadsheet",
  "hero.bullet2": "come funziona",
  "hero.bullet3": "come utilizzarlo correttamente",
  "hero.bullet4": "come valutare prodotti e informazioni",
  "hero.bullet5": "come migliorare la sicurezza degli acquisti",
  "hero.bullet6": "quali errori evitare",
  "section1.title": "Cos'è Itaobuy Spreadsheet?",
  "section1.desc": "Itaobuy Spreadsheet è una soluzione organizzata pensata per semplificare la ricerca e l'analisi dei prodotti disponibili attraverso il mercato cinese.",
  "section1.problem1": "molte informazioni diverse",
  "section1.problem2": "difficoltà nel confronto prezzi",
  "section1.problem3": "poca chiarezza sui dettagli prodotto",
  "section1.problem4": "problemi nella valutazione della qualità",
  "section1.solution": "Uno spreadsheet ben organizzato permette invece di avere una visione più chiara delle informazioni principali.",
  "section2.title": "Perché sempre più utenti cercano Itaobuy Spreadsheet?",
  "section2.desc": "Il motivo principale è semplice: gli utenti vogliono maggiore controllo. Prima di acquistare un prodotto online è importante comprendere cosa si sta acquistando, quali sono le caratteristiche, quale prezzo è corretto e quali informazioni sono disponibili.",
  "section2.conclusion": "Itaobuy Spreadsheet aiuta a trasformare una ricerca dispersiva in un processo più ordinato.",
  "section3.title": "Come funziona Itaobuy Spreadsheet?",
  "section3.subtitle": "Utilizzare Itaobuy Spreadsheet può essere suddiviso in cinque semplici passaggi.",
  "section4.title": "Itaobuy Spreadsheet è sicuro?",
  "section4.subtitle": "Questa è una delle domande più cercate dagli utenti italiani: \"itaobuy spreadsheet è sicuro?\"",
  "section4.desc": "La sicurezza dipende principalmente dalla qualità delle informazioni analizzate e dalle corrette procedure utilizzate.",
  "section5.title": "Itaobuy Spreadsheet confronto con altri metodi",
  "section6.title": "Guide Itaobuy Spreadsheet",
  "section6.subtitle": "Sul nostro sito puoi trovare guide approfondite:",
  "section7.title": "FAQ Itaobuy Spreadsheet",
  "seo_articles.title": "Guide e Approfondimenti Itaobuy Spreadsheet",
  "seo_articles.subtitle": "Scopri tutte le nostre guide per acquistare dalla Cina in modo intelligente e sicuro",
  "final_cta.title": "Vuoi conoscere meglio Itaobuy Spreadsheet?",
  "final_cta.desc": "Scopri tutte le nostre guide, tutorial e consigli aggiornati. Impara a utilizzare Itaobuy Spreadsheet in modo più intelligente, organizzato e consapevole.",
  "footer.trust": "Itaobuy Spreadsheet Italia è un sito informativo indipendente dedicato alla condivisione di guide, tutorial e informazioni educative. Non rappresentiamo direttamente piattaforme commerciali e consigliamo sempre agli utenti di verificare autonomamente informazioni, condizioni e sicurezza prima di qualsiasi acquisto.",
  "footer.copyright": "© 2026 Itaobuy Spreadsheet Italia. Tutti i diritti riservati.",
  "categories.title": "Categorie Prodotto",
  "categories.subtitle": "Esplora tutte le categorie disponibili, clicca per scoprire i prodotti",
  "article.read_more": "Leggi di più",
  "article.back_home": "Torna alla Home",
  "breadcrumb.home": "Home",
  "breadcrumb.guide": "Guide",
  "breadcrumb.article": "Guida Itaobuy Sheet 2026",
};